import React, { createContext, useState, useEffect } from "react";
import listUsers from "../methods/api/listUsers";

export const UsersContext = createContext();

export const UsersProvider = ({ children }) => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  useEffect(() => {
    listUsers().then((response) => {
    setUsers(response);
      setFilteredUsers(response);
    });
  }, []);

  return (
    <UsersContext.Provider
      value={{
        users,
        setUsers,
        filteredUsers,
        setFilteredUsers,
      }}
    >
      {children}
    </UsersContext.Provider>
  );
};
